import { ArrowUpRight } from "lucide-react";
import { SERVICES, IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ServiceBlock = ({ data, reverse }) => {
  const img = IMAGES[data.image];
  return (
    <div className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-center">
      {/* Image */}
      <Reveal
        className={`lg:col-span-5 ${reverse ? "lg:order-2" : ""}`}
      >
        <div className="relative overflow-hidden group">
          <img
            src={img}
            alt={data.heading}
            className="w-full h-[300px] lg:h-[440px] object-cover grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-[filter,transform] duration-700 ease-out"
          />
          <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
          <div className="absolute top-4 left-4 bg-obsidian/80 backdrop-blur-sm px-3 py-1.5">
            <span className="text-xs uppercase tracking-[0.2em] text-brand font-semibold">
              {data.label.split(" — ")[0]}
            </span>
          </div>
        </div>
      </Reveal>

      {/* Content */}
      <div className={`lg:col-span-7 ${reverse ? "lg:order-1" : ""}`}>
        <Reveal
          as="h3"
          className="font-display font-bold uppercase tracking-tighter text-[#f2f4f0] text-3xl sm:text-4xl lg:text-5xl leading-[0.95]"
        >
          {data.heading}
        </Reveal>
        <div className="mt-8 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {data.items.map((item, i) => (
            <Reveal
              key={item.name}
              delay={i * 0.05}
              className="bg-surface p-5 group hover:bg-surface-2 transition-colors duration-300"
              data-testid={`service-${data.image}-${i}`}
            >
              <div className="flex items-start justify-between gap-2">
                <h4 className="font-semibold text-[#f2f4f0] text-[15px]">
                  {item.name}
                </h4>
                <ArrowUpRight className="h-4 w-4 text-[#4a4f49] group-hover:text-brand transition-colors duration-200 shrink-0" />
              </div>
              <p className="mt-2 text-[13px] text-[#8d948f] leading-relaxed">
                {item.desc}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Services = () => {
  return (
    <section
      id="services"
      className="relative tech-grid bg-obsidian py-24 sm:py-32 scroll-mt-20"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="text-xs uppercase tracking-[0.3em] text-brand font-semibold">
              What We Do
            </span>
            <span className="h-px w-16 bg-white/15" />
          </div>
          <h2 className="font-display font-bold uppercase tracking-tighter text-[#f2f4f0] text-4xl sm:text-6xl lg:text-7xl leading-[0.92]">
            Two disciplines.
            <br />
            <span className="text-[#8d948f]">One standard.</span>
          </h2>
          <p className="mt-6 text-lg text-[#c7ccc4] leading-relaxed">
            From ground-up construction to season-long turf care, every service
            is scoped for commercial reliability and delivered to spec.
          </p>
        </Reveal>

        <div className="space-y-24 lg:space-y-32">
          <ServiceBlock data={SERVICES.construction} reverse={false} />
          <ServiceBlock data={SERVICES.turf} reverse={true} />
        </div>
      </div>
    </section>
  );
};
